// In dev, Vite proxy handles /api → http://localhost:7200
// In production (IIS), VITE_API_BASE_URL is set to /geoapi so calls go to
// http://geoportaluatnew.ipidata.com/geoapi/api/...
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '';

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/identity/login',
  },
  COMPANIES: '/api/company',
  USERS: '/api/user',
  SITES: '/api/site',
  WELLS: '/api/wells',
  ANNOTATIONS: '/api/annotations',
  INVENTORY: '/api/inventory',
  TOOL_MODELS: '/api/toolmodels',
  DRILL_SURVEY: '/api/drillsurvey',
} as const;

export const AUTH_STORAGE_KEY = 'geo_access_token';
